import { render } from "./CarouselList.vue?vue&type=template&id=1cf3eb82"
import script from "./CarouselList.vue?vue&type=script&lang=js"
export * from "./CarouselList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__